import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Jump from '@/components/Jump'
import Industry from '@/components/IndustryNews'

import companyProfile from '@/components/companyProfile/CompanyProfile'
import History from '@/components/companyProfile/developmentHistory'
import Enterprise from '@/components/companyProfile/enterpriseConcept'
import Honorary from '@/components/companyProfile/honorary'

import CompanyNews from '@/components/CompanyNews/companyNews'
import MediaFocus from '@/components/CompanyNews/mediaFocus'
import HouseOrgan from '@/components/CompanyNews/houseOrgan'

import CoalTrade from '@/components/ProjectIntroduction/coalTrade'
import Overseas from '@/components/ProjectIntroduction/overseasLogistics'
import Domestic from '@/components/ProjectIntroduction/domesticLogistics'
import Warehousing from '@/components/ProjectIntroduction/warehousingServices'

import Ganqimaodu from '@/components/Business/ganqimaodu'
import Mandula from '@/components/Business/mandula'
import Erenhot from '@/components/Business/erenhot'
import Seaborne from '@/components/Business/seaborne'
import Middle from '@/components/Business/middle'

import ContactUs from '@/components/ContactUs/contactUs'
import Talents from '@/components/ContactUs/talents'

import Details from '@/components/Details'

Vue.use(Router)
const router = new Router({
  router
})

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to){
  return VueRouterPush.call(this, to).catch(err => err);
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },{
      path: '/Jump',
      name: 'Jump',
      component: Jump
    },{
      path: '/Industry',
      name: 'Industry',
      component: Industry
    },{
      path: '/companyProfile',
      name: 'companyProfile',
      component: companyProfile
    },{
      path: '/History',
      name: 'History',
      component: History
    },{
      path: '/Enterprise',
      name: 'Enterprise',
      component: Enterprise
    },{
      path: '/Honorary',
      name: 'Honorary',
      component: Honorary
    },{
      path: '/CompanyNews',
      name: 'CompanyNews',
      component: CompanyNews
    },{
      path: '/MediaFocus',
      name: 'MediaFocus',
      component: MediaFocus
    },{
      path: '/HouseOrgan',
      name: 'HouseOrgan',
      component: HouseOrgan
    },{
      path: '/CoalTrade',
      name: 'CoalTrade',
      component: CoalTrade
    },{
      path: '/Overseas',
      name: 'Overseas',
      component: Overseas
    },{
      path: '/Domestic',
      name: 'Domestic',
      component: Domestic
    },{
      path: '/Warehousing',
      name: 'Warehousing',
      component: Warehousing
    },{
      path: '/Ganqimaodu',
      name: 'Ganqimaodu',
      component: Ganqimaodu
    },{
      path: '/Mandula',
      name: 'Mandula',
      component: Mandula
    },{
      path: '/Erenhot',
      name: 'Erenhot',
      component: Erenhot
    },{
      path: '/Seaborne',
      name: 'Seaborne',
      component: Seaborne
    },{
      path: '/Middle',
      name: 'Middle',
      component: Middle
    },{
      path: '/ContactUs',
      name: 'ContactUs',
      component: ContactUs
    },{
      path: '/Talents',
      name: 'Talents',
      component: Talents
    },{
      path: '/Details',
      name: 'Details',
      component: Details
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js